"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchStyled = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      '& .MuiSwitch-switchBase': {
        color: function color(_ref) {
          var checked = _ref.checked,
              _color = _ref.color,
              disabled = _ref.disabled;
          return disabled ? theme.palette.grey[400] : checked ? _color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main : theme.palette.secondary.light;
        }
      }
    }
  };
})(_Switch.default);
var _default = SwitchStyled;
exports.default = _default;